import { Permission } from '@/app/components/TeslaVehiclePermissions/TeslaVehiclePermissions'

export const batteryPermissions: Permission[] = [
  {
    title: 'Profile Information',
    description: 'Share it to access features including:',
    features: ['Personalized communication', 'Offers'],
    comingSoon: false,
  },
  {
    title: 'Vehicle Information',
    description: 'Share it to access features including:',
    features: ['Save Money or Save The Planet', 'Scheduled Departure', 'Trips'],
    comingSoon: false,
    sheetText: 'Suggested',
  },
  {
    title: 'Vehicle Location',
    description: 'Share it to access features including:',
    features: [
      'Manage Charging',
      'Save Money or Save The Planet',
      'Scheduled Departure',
      'Trips',
    ],
    comingSoon: false,
  },
  {
    title: 'Vehicle Charging Management',
    description: 'Share it to access features including:',
    features: [
      'Manage Charging',
      'Save Money or Save The Planet',
      'Scheduled Departure',
      'Trips',
    ],
    comingSoon: false,
    sheetText: 'Suggested',
  },
  {
    title: 'Vehicle Commands',
    description: 'Share it to access features including:',
    features: ['Climate Preconditioning'],
    comingSoon: false,
  },
  {
    title: 'Energy Product Information',
    description:
      'Required to see if your Powerwall(s) can enroll in any demand response (DR) programs. \n Future features include:',
    features: ['Save Money or Save The Planet'],
    comingSoon: false,
    sheetText: 'Required',
  },
  {
    title: 'Energy Product Settings',
    description:
      'Required to support controlling your Powerwall(s) during a demand response (DR) program event. \n Future features include:',
    features: ['Save Money or Save The Planet'],
    comingSoon: false,
    sheetText: 'Required',
  },
]
